import { put, call, take, fork } from 'redux-saga/effects'
import { collectionCloneService } from '../../api/course-collection'
import { collectionCloneSuccess } from '../../reducers/course-collection/action'
import { COLLECTION_CLONE } from '../../reducers/course-collection/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* collectionCloneFlow(payload) {
  try {
    const { id, callback } = payload

    const response = yield call(collectionCloneService, id)

    yield put(collectionCloneSuccess(response.data))
    yield put(operationSuccess())

    if (callback) {
      callback(response.data)
    }
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* collectionCloneWatcher() {
  while (true) {
    const action = yield take(COLLECTION_CLONE)
    const { payload } = action

    yield fork(generalSaga, collectionCloneFlow, payload)
  }
}
